/**
 * 공지사항
 *
 *  21.07.12
 */
import { ApiResponse } from '@ustra/data/src/models/api-model'
import { HttpMethod } from '@ustra/core/src/server/http/const'
import { UtraService } from '@ustra/nuxt/src/services/ustra-service'

export interface UserIdInfo {
  msgCntn?: string
  msgCd?: string
}

export class UserService extends UtraService {
  async checkUser(userid: string, password: string) {
    const result = await this.$ustra.api.call<ApiResponse<any>>({
      url: '/api/login/selectUserCheck',
      method: HttpMethod.POST,
      data: { userid, password },
    })

    return result.data?.body
  }

  async updateUserInf(emailAdr: string, tel: string, hp: string) {
    const [tela, tels, teli] = tel.split('-')
    const [hpIdntNo, hpIntmNo, hpBckNo] = hp.split('-')

    const result = await this.$ustra.api.call<ApiResponse<any>>({
      url: '/api/login/updateUserInf',
      method: HttpMethod.POST,
      data: { emailAdr, tela, tels, teli, hpIdntNo, hpIntmNo, hpBckNo },
    })

    return result.data
  }

  async getTokenStatus(refreshToken: string) {
    const result = await this.$ustra.api.call<ApiResponse<any>>({
      url: '/api/login/selectTokenStatus',
      method: HttpMethod.POST,
      data: { refreshToken },
    })

    return result.data.body
  }
}

export const userService = new UserService()
export default userService
